import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/profile.scss";

const Profile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    // Try to get email from router state first, then fallback to localStorage
    const emailFromState = location.state?.email;
    const emailFromStorage = localStorage.getItem("userEmail");
    
    if (emailFromState) {
      setUserEmail(emailFromState);
    } else if (emailFromStorage) {
      setUserEmail(emailFromStorage);
    } else {
      // If no user data is found, could optionally redirect to login
      // navigate("/login");
    }
  }, [location, navigate]);

  // Extract username from email (everything before @)
  const username = userEmail ? userEmail.split("@")[0] : "Guest User";

  const user = {
    name: username,
    email: userEmail || "No email provided",
    points: 1250,
    avatar: null,
  };

  const menuItems = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
        </svg>
      ),
      label: "My Orders",
      path: "/orders",
      badge: null,
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
        </svg>
      ),
      label: "My Favorites",
      path: "/favorites",
      badge: 5,
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z" />
        </svg>
      ),
      label: "My Coupons",
      path: "/coupons",
      badge: 3,
    },
    
  
  ];

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="profile-page color-scheme color-scheme--scheme-1">
      <Header />
      <main className="profile-page__main">
        <div className="profile-container">
          <div className="profile-header">
            <div className="profile-avatar">
              {user.avatar ? (
                <img src={user.avatar} alt={user.name} />
              ) : (
                <span className="avatar-placeholder">
                  {user.name.charAt(0).toUpperCase()}
                </span>
              )}
            </div>
            <div className="profile-info">
              <h1 className="profile-name">{user.name}</h1>
              <p className="profile-phone">{user.email}</p>
            </div>
            
          </div>

        

          <div className="profile-menu">
            {menuItems.map((item, index) => (
              <Link
                key={index}
                to={item.path}
                className="menu-item"
                onClick={toTop}
              >
                <div className="menu-icon">{item.icon}</div>
                <span className="menu-label">{item.label}</span>
                {item.value && <span className="menu-value">{item.value}</span>} 
                <div className="menu-arrow">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="18" height="18">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </div>
              </Link>
            ))}
          </div>

          <button className="logout-btn" onClick={() => {
            localStorage.removeItem("userEmail");
            navigate("/login");
          }}>
            Log Out
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Profile;
